/**
 * Created by su0012004  on 2020/9/06.
 */

// import navigation from '@/components/model/navigation/navigation'
// class ad   {
// }
import Model from '@/components/model/model';
class navigation extends Model{
 }



//
// Request URL:
navigation.main_lists = function (data){
  let url = '/pc_v1/navigation/index/main_lists.html';
  return this.get(url, data);
}


//  // 底部导航 footer_lists
navigation.footer_lists = function (data){
  let url = '/pc_v1/navigation/index/footer_lists.html';
  return this.get(url, data);
}



export default navigation;



// WEBPACK FOOTER //
// ./src/components/model/navigation/navigation.js